<template>
	<main>
		<div class="left">
			<div class="up"><Editor /></div>
			<div class="down"><WidgetList /></div>
		</div>
		<div class="right">
			<AttrList />
		</div>
	</main>
	<div v-for="node in state.rootWidget.realNodes" :key="node.id">
		<Node :me="node"/>
	</div>
</template>

<script lang="ts">
import { defineComponent, provide, reactive } from 'vue';
import Editor from './components/Editor.vue';
import WidgetList from './components/WidgetList.vue';
import AttrList from './components/AttrList.vue';
import { Widget, widgetType, dataKey, State } from './types';
import createWidget from './widget/createWidget';

export default defineComponent({
	components: { Editor, WidgetList, AttrList },
	setup() {
		const rootWidget: Widget = createWidget(widgetType.LIST);
		const curWidget = reactive<Widget>(rootWidget);
		// 共享数据
		const state = reactive<State>({
			rootWidget,
			curWidget,
		});

		provide(dataKey.STATE, state);
		return { state, widgetType };
	},
});
</script>

<style scoped>
main {
	margin: 10px auto;
	padding: 20px;
	width: 80%;
	background: yellow;
	display: flex;
	justify-content: space-between;
}
.left {
	flex-basis: 50%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
</style>
